import { jsxs as k, jsx as s } from "react/jsx-runtime";
import c, { useEffect as d } from "react";
import p, { css as x } from "styled-components";
import { f as E, b as _, a as $ } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { R as q } from "../chunks/Description.be3b00d1.js";
const z = p.div.withConfig({
  displayName: "RangoInputCode",
  componentId: "sc-12qa3ti-0"
})(["width:100%;min-width:312px;display:flex;flex-direction:column;align-items:center;box-sizing:border-box;gap:var(--spacing-2x);& input{", " width:var(--size-5x);height:var(--size-7x);color:var(--active-placeholder-color);border-radius:var(--default-border-radius);text-align:center;background-color:transparent;border:none;border:var(--border-width-xs) solid var(--elements-border-color);outline:none;padding:0px;margin:0px;transition-property:background-color,opacity;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-01);&:focus{border-color:var(--active-border-color);}", " &:hover:not(:focus){", " border-color:transparent;transition-timing-function:var(--curve-productive-entrance);}}"], E, ({
  $focus: r
}) => r && x(["&:focus{", " outline-offset:2px;}"], _), $), L = p.div.withConfig({
  displayName: "InputsContainer",
  componentId: "sc-12qa3ti-1"
})(["display:flex;flex-direction:row;align-items:flex-start;gap:var(--spacing-1x);"]), S = p.div.withConfig({
  displayName: "InputWrapper",
  componentId: "sc-12qa3ti-2"
})(["position:relative;input[type='password']{color:transparent;}", ""], ({
  $type: r
}) => r === "password" && x(["&:after{content:'';position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:var(--size-1x);height:var(--size-1x);border-radius:var(--border-radius-circular);background-color:var(--active-icon-color);}"])), F = p(q).withConfig({
  displayName: "Description",
  componentId: "sc-12qa3ti-3"
})(["a{color:var(--text-description-color);text-decoration:none;border-bottom:1.5px solid var(--text-description-color);}"]), j = "rango-input-code-outline", D = c.forwardRef(({
  value: r = "",
  items: n = 0,
  hidden: u,
  onChangeValue: l,
  children: b,
  ...h
}, y) => {
  const f = c.useRef(), [a, g] = c.useState(r.slice(0, n).split("")), [I, v] = c.useState(!1), m = (t) => {
    t.key === "Tab" && v(!0);
  };
  d(() => (document.addEventListener("keydown", () => m(event)), () => {
    document.removeEventListener("keydown", () => m(event));
  }), []), d(() => {
    g(r.slice(0, n).split(""));
  }, [r, n]), d(() => {
    R();
  }, a);
  const w = (t, e) => {
    const o = [...a];
    o[t] = e, g([...o]);
  }, C = (t, e) => {
    const o = Array.from(f.current.querySelectorAll("input"));
    let i = null;
    e ? i = o[t + 1] : i = o[t - 1], i && (i.focus(), i.select());
  }, R = () => {
    const t = a.join("");
    t.length === n && l && l(t);
  }, A = (t, e) => {
    const o = t.target;
    w(e, o.value), C(e, o.value);
  }, N = (t) => {
    t.target.select();
  };
  return /* @__PURE__ */ k(z, { ref: y, $focus: I, "data-rango-component": "rango-input-code", "data-is-rango": !0, ...h, children: [
    /* @__PURE__ */ s(L, { ref: f, children: (() => {
      let t = [];
      for (let e = 0; e < n; e++)
        t.push(/* @__PURE__ */ s(S, { $type: u && a[e] ? "password" : "text", children: /* @__PURE__ */ s("input", { id: `${j}-${e}`, "aria-label": `input ${e + 1}`, value: a[e] || "", tabIndex: 0, type: u ? "password" : "text", maxLength: 1, onInput: (o) => A(o, e), onFocus: N, onClick: () => v(!1) }, e) }));
      return t;
    })() }),
    /* @__PURE__ */ s(F, { children: b })
  ] });
});
D.displayName = "RangoInputCode";
export {
  D as RangoInputCode
};
